import styled from 'styled-components';

type InputProps = {
  ref?: React.LegacyRef<HTMLInputElement>;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = ({ value, onChange, placeholder, label, ref, ...props }: InputProps) => {
  return (
    <Container>
      {label && <StyledLabel>{label}</StyledLabel>}
      <StyledInput
        ref={ref}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        {...props}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;
`;

const StyledInput = styled.input`
  padding: 0.5rem;
  border-radius: 0.3rem;
  border: 1px solid ${({ theme }) => theme.colors.gray500};
`;

export const StyledLabel = styled.label`
  color: ${({ theme }) => theme.colors.gray900};
  font-weight: 500;
  font-size: 0.9rem;
`;
